<template>
	<div class="basic_wrap">
		<!-- 顶部标题 -->
		<div class="deposit_header">
			<div class="back_left" @click="goBack">
				<img src="../../../src/assets/images/return.png" alt="">
			</div>
			<div class="big_tit">{{ $t('invest.UserDeposit') }}</div>
		</div>

		<!-- 主要内容区域 -->
		<div class="main_content">
			<!-- 未审核提示 -->
			<div v-if="hasPendingDeposit" class="pending_warning">
				<span class="warning_icon">⚠️</span>
				<span class="warning_text">{{ $t('invest.weixiantishi') }}</span>
			</div>
			
			<!-- 目前金额 -->
			<div class="info_row line_bottom">
				<div class="info_label">{{ $t('invest.CurrentAmount') }}</div>
				<div class="info_value">{{ currentBalance }}</div>
			</div>

			<!-- 支付类型 -->
			<div class="info_row currency_row">
				<div class="info_label">{{ $t('invest.PaymentType') }}:</div>
				<div class="currency_input" @click="showPaymentTypePicker">
					<span class="currency_text">{{ selectedPaymentType }}</span>
					<span class="arrow_down" :class="{ 'arrow_up': showPaymentTypeDropdown }">▼</span>
					<!-- 支付类型下拉选择器 -->
					<div class="currency_dropdown" v-if="showPaymentTypeDropdown">
						<div 
							v-for="payment in paymentMethods" 
							:key="payment.id"
							class="currency_option"
							:class="{ 'selected': payment.id === selectedPaymentId }"
							@click.stop="selectPaymentType(payment)"
						>
							{{ payment.name }}
						</div>
					</div>
				</div>
			</div>

			<!-- 充值地址 -->
			<div class="info_row currency_row" v-if="selectedPayment && (selectedPayment.qrcode || (selectedPayment.type === 4 && selectedPayment.account))">
				<div class="info_label">{{ selectedPayment.type === 4 ? $t('invest_bank.account') : $t('invest_qrcode.walletAddress') }}</div>
				<div class="currency_input recharge_input">
				<div class="address_text">
					<div class="address_value">{{ selectedPayment.type === 4 ? selectedPayment.account : selectedPayment.qrcode }}</div>
					<div class="copy_btn" @click="copyAddress">{{$t('user.copyAddress')}}</div>
				</div>
				</div>
			</div>

			<!-- 充值金额 -->
			<div class="info_row line_bottom">
				<div class="info_label">{{ $t('invest.RechargeAmount') }}</div>
				<div class="info_value">
					<input 
						type="number" 
						v-model="rechargeAmount" 
						:placeholder="$t('invest.Pleaseenterrechargeamount')" 
						class="amount_input"
						@input="calculateCNYAmount"
					>
				</div>
			</div>

			<!-- 选择货币 -->
			<div class="info_row currency_row">
				<div class="info_label">{{ $t('invest.SelectCurrency') }}:</div>
				<div class="currency_input" 
					:class="{ 'disabled': !selectedPayment || selectedPayment.type !== 4 }"
					@click="selectedPayment && selectedPayment.type === 4 ? showCurrencyPicker() : null">
					<span class="currency_text">{{ selectedCurrency }}</span>
					<span class="arrow_down" :class="{ 'arrow_up': showCurrencyDropdown }">▼</span>
					<!-- 货币下拉选择器 -->
					<div class="currency_dropdown" v-if="showCurrencyDropdown && selectedPayment && selectedPayment.type === 4">
						<div 
							v-for="currency in currencyOptions" 
							:key="currency.value"
							class="currency_option"
							:class="{ 'selected': currency.value === selectedCurrency }"
							@click.stop="selectCurrency(currency.value)"
						>
							{{ currency.label }}
						</div>
					</div>
				</div>
			</div>

	<!-- CNY金额 -->
	<div class="info_row">
		<div class="info_label">{{$t('user.arrivedAmount')}}</div>
		<div class="info_value">{{ cnyAmount }}</div>
	</div>

	<!-- 上传凭证区域 -->
	<div class="info_row upload_row_full">
		<div class="upload_container_full">
			<div class="upload_box" @click="triggerFileUpload" v-if="!voucherImageUrl">
				<div class="upload_icon">+</div>
				<div class="upload_text">{{$t('user.uploadVoucher')}}</div>
				<div class="required_tip">{{$t('user.required')}}</div>
			</div>
				<div class="image_preview" v-if="voucherImageUrl">
					<img :src="voucherImageUrl" alt="凭证" class="preview_img" @click="previewImage">
					<div class="delete_btn" @click.stop="deleteImage">×</div>
				</div>
				<input 
					type="file" 
					ref="fileInput" 
					accept="image/*" 
					style="display: none;" 
					@change="handleFileChange"
				>
			</div>
		</div>

		<!-- 支付方式选择 -->
			<div class="payment_methods_section" v-if="paymentMethods.length > 0" v-show="false">
				<div class="section_title">{{ $t('invest.paymentMethod') }}</div>
				<div class="payment_list">
					<div 
						v-for="(payment, index) in paymentMethods" 
						:key="payment.id" 
						class="payment_item" 
						:class="{ 'selected': selectedPaymentId === payment.id }"
						@click="selectPaymentMethod(payment)"
					>
						<div class="payment_check">
							<div class="check_icon" :class="{ 'checked': selectedPaymentId === payment.id }"></div>
						</div>
						<div class="payment_info">
							<div class="payment_icon">
								<img v-if="payment.logo" :src="payment.logo" :alt="payment.name" />
								<div v-else class="default_icon">{{ getPaymentTypeIcon(payment.type) }}</div>
							</div>
							<div class="payment_details">
								<div class="payment_name">{{ payment.name }}</div>
								<div class="payment_desc" v-if="payment.description">{{ payment.description }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 提交按钮 -->
			<div 
				class="submit_btn" 
				@click="submitDeposit" 
				:class="{ 'loading': loading, 'disabled': isSubmitting || hasPendingDeposit }"
			>
				<span v-if="isSubmitting">提交中...</span>
				<span v-else-if="loading" class="loading_text">处理中...</span>
				<span v-else>{{ $t('login.submit') }}</span>
			</div>
		</div>

		<!-- 底部导航栏 -->
		<FooterTab :activeType="'user'" />
	</div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
	name: "Deposit",
	data() {
		return {
			show_icon_type: 'index',
			currentBalance: '0.00',
			selectedPaymentType: '',
			// 支付类型选项
			paymentTypeOptions: [
				{ value: 'BTC', label: 'BTC' },
				{ value: 'ETH', label: 'ETH' },
				{ value: 'TRC20', label: 'TRC20' },
				{ value: 'ERC20', label: 'ERC20' },
				{ value: '银行卡', label: '银行卡' }
			],
			showPaymentTypeDropdown: false,
			rechargeAmount: '0',
			selectedCurrency: this.$t('invest.USD'),
			cnyAmount: '0',
			showCurrencyDropdown: false,
			currencyOptions: [],
			// 新增充值相关数据
			paymentMethods: [], // 支付方式列表
			minRecharge: 100, // 最低充值金额
			loading: false, // 加载状态
			selectedPaymentId: null, // 选中的支付方式ID
			rechargeConfig: null, // 充值配置信息
			// 图片上传相关
			voucherImageUrl: '', // 凭证图片预览URL
			voucherImageFile: null, // 凭证图片文件
			hasPendingDeposit: false, // 是否有未审核的充值记录
			isSubmitting: false, // 是否正在提交中
		};
	},
	components: { FooterTab },
	computed: {
		// 当前选中的支付方式对象
		selectedPayment() {
			return this.paymentMethods.find(payment => payment.id === this.selectedPaymentId) || null;
		}
	},
	created() {
		this.$parent.footer("user", false);
		this.show_icon_type = 'index';
		// 获取用户余额
		this.getUserBalance();
		// 获取充值配置和支付方式
		this.getRechargeConfig();
		// 获取货币汇率
		this.getCurrencyRates();
		// 初始化CNY金额
		this.calculateCNYAmount();
		// 检查是否有未审核的充值记录
		this.checkPendingDeposit();
	},
	methods: {
		goBack() {
			// 返回到用户中心页面
			this.$router.push('/userCenter');
		},
		
		// 复制钱包地址
		copyAddress() {
			let addressToCopy = '';
			if (this.selectedPayment) {
				if (this.selectedPayment.type === 4 && this.selectedPayment.account) {
					// 银行卡类型，复制账户号码
					addressToCopy = this.selectedPayment.account;
				} else if (this.selectedPayment.qrcode) {
					// 其他类型，复制二维码地址
					addressToCopy = this.selectedPayment.qrcode;
				}
			}
			
			if (addressToCopy) {
				// 创建临时文本区域来复制文本
				const textArea = document.createElement('textarea');
				textArea.value = addressToCopy;
				document.body.appendChild(textArea);
				textArea.select();
				document.execCommand('copy');
				document.body.removeChild(textArea);
				this.$toast && this.$toast(this.$t('invest_qrcode.copySucceeded'));
				console.log('📋 复制地址:', addressToCopy);
			}
		},
		async getUserBalance() {
			try {
				const result = await Fetch('/user/info');
				if (result && result.code === 1) {
					this.currentBalance = result.data.money || '0.00';
					console.log('✅ 获取用户余额成功:', this.currentBalance);
				} else {
					console.error('❌ 获取用户余额失败:', result);
				}
			} catch (error) {
				console.error('💥 获取用户余额出错:', error);
			}
		},
		
		// 获取货币汇率
		async getCurrencyRates() {
			try {
				console.log('💱 开始获取货币汇率...');
				const result = await Fetch('/index/currency_rates', {
					language: localStorage.getItem('lang') || 'zh_hk'
				});
				
				console.log('💱 货币汇率API响应:', result);
				
				if (result && result.code === 1 && result.data) {
					console.log('✅ 货币汇率获取成功');
					
					// 转换API数据为前端需要的格式
					this.currencyOptions = result.data.map(rate => ({
						value: rate.currency_name,
						label: rate.currency_name,
						rate: parseFloat(rate.exchange_rate),
						code: rate.currency_code
					}));
					
					// 设置默认选中的货币（美元）
					const usdOption = this.currencyOptions.find(option => option.code === 'HKD');
					if (usdOption) {
						this.selectedCurrency = usdOption.value;
					} else if (this.currencyOptions.length > 0) {
						// 如果没有美元，选择第一个
						this.selectedCurrency = this.currencyOptions[0].value;
					}
					
					console.log('💱 货币选项列表:', this.currencyOptions);
					console.log('💱 默认选中货币:', this.selectedCurrency);
					
				} else {
					console.error('❌ 货币汇率获取失败:', result);
					// 使用默认汇率作为兜底
					this.setDefaultCurrencyOptions();
				}
			} catch (error) {
				console.error('💥 获取货币汇率出错:', error);
				// 使用默认汇率作为兜底
				this.setDefaultCurrencyOptions();
			}
		},
		
		// 设置默认货币选项（兜底方案）
		setDefaultCurrencyOptions() {
			console.log('🔄 使用默认货币汇率');
			this.currencyOptions = [
				{ value: this.$t('invest.USD'), label: this.$t('invest.USD'), rate: 7.2, code: 'USD' },
				{ value: this.$t('invest.CNY'), label: this.$t('invest.CNY'), rate: 1.0, code: 'CNY' },
				{ value: this.$t('invest.EUR'), label: this.$t('invest.EUR'), rate: 7.8, code: 'EUR' },
				{ value: this.$t('invest.JPY'), label: this.$t('invest.JPY'), rate: 0.048, code: 'JPY' },
				{ value: this.$t('invest.HKD'), label: this.$t('invest.HKD'), rate: 0.93, code: 'HKD' }
			];
			this.selectedCurrency = this.$t('invest.USD');
		},
		
		// 获取充值配置和支付方式
		async getRechargeConfig() {
			try {
				console.log('💰 开始获取充值配置...');
				const result = await Fetch('/user/recharge');
				
				console.log('💰 充值配置API响应:', result);
				
				if (result && result.code === 1 && result.data) {
					console.log('✅ 充值配置获取成功');
					
					this.rechargeConfig = result.data;
					this.paymentMethods = result.data.payment || [];
					this.minRecharge = result.data.min_recharge || 100;
					
					// 默认选择第一个支付方式
					if (this.paymentMethods.length > 0) {
						this.selectedPaymentId = this.paymentMethods[0].id;
						this.selectedPaymentType = this.paymentMethods[0].name;
						
						// 选择支付方式后重新计算到账金额
						this.$nextTick(() => {
							this.calculateCNYAmount();
						});
					}
					
					console.log('💰 支付方式列表:', this.paymentMethods);
					console.log('💰 最低充值金额:', this.minRecharge);
					
				} else {
					console.error('❌ 充值配置获取失败:', result);
					this.$toast && this.$toast('获取充值配置失败');
				}
			} catch (error) {
				console.error('💥 获取充值配置出错:', error);
				this.$toast && this.$toast('获取充值配置出错');
			}
		},
		
		showPaymentTypePicker() {
			// 切换支付类型下拉框的显示状态
			this.showPaymentTypeDropdown = !this.showPaymentTypeDropdown;
			console.log('切换支付类型下拉框:', this.showPaymentTypeDropdown);
		},
		
		// 选择支付类型
	selectPaymentType(payment) {
		console.log('💰 选择支付类型:', payment);
		const previousPaymentType = this.selectedPayment ? this.selectedPayment.type : null;
		
		this.selectedPaymentId = payment.id;
		this.selectedPaymentType = payment.name;
		this.showPaymentTypeDropdown = false;
		
		// 如果从银行卡(type=4)切换到数字货币(type!=4)，自动切换货币为美元
		if (previousPaymentType === 4 && payment.type !== 4) {
			console.log('💱 從銀行卡切換到數字貨幣，自動切換為美元');
			const usdOption = this.currencyOptions.find(option => option.code === 'USD');
			if (usdOption) {
				this.selectedCurrency = usdOption.value;
				console.log('💱 已自動切換為:', this.selectedCurrency);
			}
		}
		
		// 如果从银行卡(type=4)切换到数字货币(type!=4)，自动切换货币为美元
		if (previousPaymentType !== 4 && payment.type === 4) {
			console.log('💱 從數字貨幣切換到銀行卡，自動切換為港元');
			const usdOption = this.currencyOptions.find(option => option.code === 'HKD');
			if (usdOption) {
				this.selectedCurrency = usdOption.value;
				console.log('💱 已自動切換為:', this.selectedCurrency);
			}
		}
		
		// 重新计算到账金额
		this.calculateCNYAmount();
	},
		
	// 选择支付方式
	selectPaymentMethod(payment) {
		console.log('💰 选择支付方式:', payment);
		const previousPaymentType = this.selectedPayment ? this.selectedPayment.type : null;
		
		this.selectedPaymentId = payment.id;
		this.selectedPaymentType = payment.name;
		
		// 如果从银行卡(type=4)切换到数字货币(type!=4)，自动切换货币为美元
		if (previousPaymentType === 4 && payment.type !== 4) {
			console.log('💱 從銀行卡切換到數字貨幣，自動切換為美元');
			const usdOption = this.currencyOptions.find(option => option.code === 'USD');
			if (usdOption) {
				this.selectedCurrency = usdOption.value;
				console.log('💱 已自動切換為:', this.selectedCurrency);
			}
		}
		
		// 重新计算到账金额
		this.calculateCNYAmount();
	},
		
		// 获取支付方式图标
		getPaymentTypeIcon(type) {
			switch (type) {
				case 1:
					return '₿'; // USDT/加密货币
				case 2:
					return '💰'; // 支付宝
				case 3:
					return '💚'; // 微信
				case 4:
					return '🏦'; // 银行卡
				case 5:
					return '💳'; // 第三方支付
				default:
					return '💰';
			}
		},
		showCurrencyPicker() {
			// 显示/隐藏货币选择器
			this.showCurrencyDropdown = !this.showCurrencyDropdown;
		},
		selectCurrency(currency) {
			// 选择货币
			this.selectedCurrency = currency;
			this.showCurrencyDropdown = false;
			// 重新计算CNY金额
			this.calculateCNYAmount();
		},
		
		calculateCNYAmount() {
			// 计算USD到账金额
			// 公式：到账金额(USD) = 充值金额 × 货币汇率(exchange_rate) × 支付类型汇率(payment.rate)
			const amount = parseFloat(this.rechargeAmount) || 0;
			const selectedCurrencyData = this.currencyOptions.find(item => item.value === this.selectedCurrency);
			
			if (selectedCurrencyData && this.selectedPayment) {
				const currencyRate = selectedCurrencyData.rate; // 货币汇率 (exchange_rate)
				const paymentRate = parseFloat(this.selectedPayment.rate) || 1; // 支付类型汇率 (payment.rate)
				
				// 到账金额 = 充值金额 × 货币汇率 × 支付类型汇率
				this.cnyAmount = (amount * currencyRate * paymentRate).toFixed(2);
				
				console.log('💰 计算到账金额:', {
					充值金额: amount,
					货币汇率: currencyRate,
					支付类型汇率: paymentRate,
					到账金额USD: this.cnyAmount
				});
			} else if (selectedCurrencyData) {
				// 如果没有选择支付方式，默认使用货币汇率计算（支付类型汇率按1计算）
				const rate = selectedCurrencyData.rate;
				this.cnyAmount = (amount * rate).toFixed(2);
			}
		},
		
		// 触发文件选择
		triggerFileUpload() {
			this.$refs.fileInput.click();
		},
		
		// 处理文件选择
		handleFileChange(event) {
			const file = event.target.files[0];
			if (!file) return;
			
			// 验证文件类型
			if (!file.type.startsWith('image/')) {
				this.$toast && this.$toast('請選擇圖片文件');
				return;
			}
			
			// 验证文件大小（限制5MB）
			if (file.size > 5 * 1024 * 1024) {
				this.$toast && this.$toast('图片大小不能超过5MB');
				return;
			}
			
			this.voucherImageFile = file;
			
			// 创建预览URL
			const reader = new FileReader();
			reader.onload = (e) => {
				this.voucherImageUrl = e.target.result;
			};
			reader.readAsDataURL(file);
			
			console.log('📷 选择的图片:', file.name, '大小:', (file.size / 1024).toFixed(2) + 'KB');
		},
		
		// 删除图片
		deleteImage() {
			this.voucherImageUrl = '';
			this.voucherImageFile = null;
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
			console.log('🗑️ 删除凭证图片');
		},
		
		// 预览图片
		previewImage() {
			if (this.voucherImageUrl) {
				// 使用vant的ImagePreview组件
				if (this.$imagePreview) {
					this.$imagePreview([this.voucherImageUrl]);
				} else {
					// 如果没有安装ImagePreview，就在新标签页打开
					window.open(this.voucherImageUrl);
				}
			}
		},
		
		// 上传图片到服务器
		async uploadVoucherImage() {
			if (!this.voucherImageFile) {
				return null;
			}
			
			try {
				console.log('📤 开始上传凭证图片...');
				
				const formData = new FormData();
				formData.append('file', this.voucherImageFile);
				formData.append('token', localStorage.getItem('token'));
				
				// 使用axios直接上传，不经过fetch.js的封装
				const axios = require('axios');
				const api = require('../../interface/index').default;
				
				const response = await axios.post(api.commonUrl + '/api/user/upload_voucher', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				
				console.log('📤 上传响应:', response.data);
				
				if (response.data && response.data.code === 1) {
					console.log('✅ 图片上传成功:', response.data.data.url);
					return response.data.data.url;
				} else {
					console.error('❌ 图片上传失败:', response.data);
					this.$toast && this.$toast(response.data.info || '图片上传失败');
					return null;
				}
			} catch (error) {
				console.error('💥 图片上传出错:', error);
				this.$toast && this.$toast('图片上传失败，请重试');
				return null;
			}
	},
	
	// 检查是否有未审核的充值记录
	async checkPendingDeposit() {
		try {
			const result = await Fetch('/user/recharge_list', {
				language: localStorage.getItem('lang') || 'zh_hk'
			});
			if (result && result.code === 1 && result.data && result.data.list) {
				// 检查是否有status=0的记录（待审核）
				const pendingRecords = result.data.list.filter(record => record.status === 0);
				this.hasPendingDeposit = pendingRecords.length > 0;
				
				if (this.hasPendingDeposit) {
					console.log('檢測到未審核的充值記錄:', pendingRecords);
				}
			}
		} catch (error) {
			console.error('檢查充值記錄失敗:', error);
		}
	},
	
	async submitDeposit() {
		// 防止重复提交
		if (this.isSubmitting) {
			this.$toast && this.$toast('提交中，請稍候...');
			return;
		}
		
		// 先重新检查一次是否有未审核的充值记录（实时检查）
		try {
			const checkResult = await Fetch('/user/recharge_list', {
				language: localStorage.getItem('lang') || 'zh_hk'
			});
			if (checkResult && checkResult.code === 1 && checkResult.data && checkResult.data.list) {
				const pendingRecords = checkResult.data.list.filter(record => record.status === 0);
				if (pendingRecords.length > 0) {
					this.hasPendingDeposit = true;
					// this.$toast && this.$toast('您有未審核的充值申請，請等待審核完成後再提交新的申請');
					return;
				}
				this.hasPendingDeposit = false;
			}
		} catch (error) {
			console.error('檢查充值記錄失敗:', error);
		}
		
		// 检查是否有未审核的充值记录
		if (this.hasPendingDeposit) {
			this.$toast && this.$toast(this.$t('invest.weixiantishi'));
			return;
		}
		
		try {
			// 验证输入 - 以CNY金额为准
			const cnyAmountValue = parseFloat(this.cnyAmount);
			if (!this.cnyAmount || cnyAmountValue <= 0) {
				this.$toast && this.$toast(this.$t('invest_qrcode.shuruyoxiaojiner') || '請輸入有效的充值金額！');
				return;
			}
			
			if (cnyAmountValue < this.minRecharge) {
				this.$toast && this.$toast(`充值金额不能少于$${this.minRecharge}`);
				return;
			}
			
			if (!this.selectedPaymentId) {
				this.$toast && this.$toast(this.$t('invest_qrcode.xuanzhezhifufangsi') || '請選擇支付方式！');
				return;
			}
			
			// 验证必须上传交易凭证
			if (!this.voucherImageFile) {
				this.$toast && this.$toast(this.$t('invest_qrcode.shangchuanchongzhipingzheng') || '请上传充值凭证！');
				return;
			}
			
			// 设置提交状态
			this.isSubmitting = true;
			this.loading = true;
				console.log('💰 开始提交充值请求...');
				console.log('💰 原始金额:', this.rechargeAmount, this.selectedCurrency);
				console.log('💰 CNY金额:', this.cnyAmount);
				
				// 先上传凭证图片（必须上传）
				let voucherImageUrl = '';
				if (this.voucherImageFile) {
					voucherImageUrl = await this.uploadVoucherImage();
					if (!voucherImageUrl) {
						// 上传失败，停止提交
						this.loading = false;
						return;
					}
				}
				
				// 构建详细的充值描述信息
				let detailedReason;
				if (this.selectedCurrency === '人民币' || this.selectedCurrency.includes('CNY')) {
					detailedReason = `充值CNY ${cnyAmountValue}元`;
				} else {
					detailedReason = `充值${this.rechargeAmount}${this.selectedCurrency}(≈CNY ${cnyAmountValue})`;
				}
				
				// 参考银行卡页面的提交方式，先创建充值订单
				const createResult = await Fetch('/user/recharge_type', {
					money: cnyAmountValue, // 使用CNY金额
					original_amount: this.rechargeAmount, // 原始输入金额
					currency: this.selectedCurrency, // 选择的货币
					id: this.selectedPaymentId,
					reason: detailedReason, // 使用详细的充值描述
					voucher_image: voucherImageUrl, // 添加凭证图片URL
					language: localStorage.getItem('lang') || 'zh_hk'
				});
				
				console.log('💰 创建充值订单响应:', createResult);
				
				if (createResult && createResult.code === 1 && createResult.data) {
					// 立即提交充值申请（参考银行卡页面的submitBtn方法）
					const applyResult = await Fetch('/user/recharge_apply', {
						id: createResult.data.orderId,
						voucher_image: voucherImageUrl // 同时也传递给申请接口
					});
					
					console.log('💰 提交充值申请响应:', applyResult);
					
					if (applyResult && applyResult.code === 1) {
						console.log('✅ 充值成功');
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully') || '充值成功！',
						});
						
						// 设置为有未审核记录（提交成功后立即有待审核记录）
						this.hasPendingDeposit = true;
						
						// 清空表单
						this.rechargeAmount = '0';
						this.cnyAmount = '0';
						// 重置为美元
						const usdOption = this.currencyOptions.find(option => option.code === 'USD');
						this.selectedCurrency = usdOption ? usdOption.value : (this.currencyOptions.length > 0 ? this.currencyOptions[0].value : 'USD');
						this.deleteImage(); // 清空图片
						
						// 刷新用户余额
						setTimeout(() => {
							this.getUserBalance();
						}, 1000);
						
						// 重新检查未审核记录
						this.checkPendingDeposit();
						
					} else {
						console.error('❌ 充值申请失败:', applyResult);
						this.$toast && this.$toast({
							message: applyResult.info || '充值申请失败',
							type: 'error',
							duration: 3000
						});
					}
					
				} else {
					console.error('❌ 创建充值订单失败:', createResult);
					let message = '';
					if (createResult && typeof createResult.info === 'string') {
						message = createResult.info;
					} else if (createResult && typeof createResult.info === 'object') {
						const currentLang = localStorage.getItem('lang') || 'zh_hk';
						message = createResult.info[currentLang] || createResult.info.zh_cn || '创建充值订单失败';
					} else {
						message = '创建充值订单失败';
					}
					this.$toast && this.$toast({
						message: message,
						type: 'error',
						duration: 3000
					});
				}
				
			} catch (error) {
				console.error('💥 充值请求出错:', error);
				// 网络错误已经在fetch.js中处理了，这里不重复提示
			} finally {
				this.loading = false;
				// 无论成功还是失败，都要重置提交状态
				this.isSubmitting = false;
			}
		}
	}
};
</script>

<style lang="less" scoped>
.basic_wrap {
	// min-height: 100vh;
	background: #ffffff;
	display: flex;
	flex-direction: column;
}

/* 顶部标题 */
.deposit_header {
	position: relative;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #ffffff;
	border-bottom: 1px solid #f0f0f0;

	.back_left {
		position: absolute;
		left: 15px;
		cursor: pointer;
		img{
			width: 16px;
		}
	}

	.big_tit {
		font-size: 16px;
		font-weight: 500;
		color: #333;
	}
}

/* 主要内容区域 */
.main_content {
	flex: 1;
	padding: 20px;
}

/* 未审核警告提示 */
.pending_warning {
	margin: 0 0 15px 0;
	padding: 12px 15px;
	background: #fff3e0;
	border-left: 4px solid #ff9800;
	border-radius: 4px;
	display: flex;
	align-items: center;
	
	.warning_icon {
		font-size: 20px;
		margin-right: 10px;
	}
	
	.warning_text {
		flex: 1;
		font-size: 14px;
		color: #e65100;
		line-height: 1.5;
	}
}

/* 信息行 */
.info_row {
	display: flex;
	align-items: center;
	padding: 15px 0;
	// border-bottom: 1px solid #f0f0f0;

	.info_label {
		font-size: 16px;
		color: #333;
		font-weight: 500;
		width: 33.33%;
	}

	.info_value {
		font-size: 16px;
		color: #333;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		width: 33.33%;
		text-align: center;

		&.selectable {
			cursor: pointer;
			// color: #1890ff;
		}

		.arrow_right {
			color: #999;
			font-size: 14px;
		}

		.arrow_down {
			color: #999;
			font-size: 12px;
			transition: transform 0.3s;
			
			&.arrow_up {
				transform: rotate(180deg);
			}
		}
	}

	.info_value_arrow{
		width: 33.33%;
		display: flex;
		align-items: center;
		justify-content: center;
		
		img{
			width: 16px;
			height: 16px;
		}
	}
}

/* 两元素行的样式（标签在左，值在中，右列空） */
.info_row:not(:has(.info_value_arrow)) {
	.info_label {
		width: 33.33%;
	}
	
	.info_value {
		width: 33.33%;
		justify-content: center;
	}
	
	/* 右列空着，但保持宽度 */
	&::after {
		content: '';
		width: 33.33%;
	}
}

/* 三元素行的样式（标签在左，值在中，箭头在右） */
.info_row:has(.info_value_arrow) {
	.info_label {
		width: 33.33%;
	}
	
	.info_value {
		width: 33.33%;
		justify-content: center;
	}
	
	.info_value_arrow {
		width: 33.33%;
		justify-content: right;
	}
}
.line_bottom{
	border-bottom: 1px solid #f0f0f0;
}

/* 货币行相对定位 */
.currency_row {
	position: relative;
	
	/* 覆盖通用样式，确保货币行只有两列 */
	.info_label {
		width: 33.33% !important;
	}
	
	.currency_input {
		width: 66.67% !important;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #e0e0e0;
		border-radius: 2px;
		padding: 12px 16px;
		cursor: pointer;
		transition: all 0.3s;
		
		&:hover {
			border-color: #1890ff;
		}
		
		&.disabled {
			cursor: not-allowed;
			background-color: #f5f5f5;
			color: #999;
			
			&:hover {
				border-color: #e0e0e0;
			}
			
			.currency_text {
				color: #999;
			}
			
			.arrow_down {
				color: #ccc;
			}
		}
		
		.currency_text {
			font-size: 16px;
			color: #333;
		}
		
		.arrow_down {
			color: #999;
			font-size: 12px;
			transition: transform 0.3s;
			
			&.arrow_up {
				transform: rotate(180deg);
			}
		}
	}
	
	/* 移除通用样式的::after伪元素 */
	&::after {
		display: none !important;
	}
}

/* 货币下拉选择器 */
.currency_dropdown {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	background: #ffffff;
	border: 1px solid #e8e8e8;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	z-index: 1000;
	max-height: 200px;
	overflow-y: auto;
	
	.currency_option {
		padding: 12px 16px;
		cursor: pointer;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #f0f0f0;
		transition: background-color 0.2s;
		
		&:last-child {
			border-bottom: none;
		}
		
		&:hover {
			background-color: #f5f5f5;
		}
		
		&.selected {
			background-color: #1890ff;
			color: #ffffff;
		}
	}
}

/* 金额输入框 */
.amount_input {
	border: none;
	background: transparent;
	font-size: 16px;
	color: #333;
	text-align: center;
	width: 120px;
	
	&:focus {
		outline: none;
	}
}

/* 提交按钮 */
.submit_btn {
	width: 100%;
	height: 48px;
	background: #1890ff;
	color: #ffffff;
	border: none;
	border-radius: 50px;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 30px;
	transition: all 0.3s;
	
	&:hover {
		background: #40a9ff;
	}
	
	&.disabled {
		background: #d9d9d9;
		cursor: not-allowed;
		opacity: 0.6;
	}
	
	&.loading {
		background: #ccc;
		cursor: not-allowed;
		
		&:hover {
			background: #ccc;
		}
	}
	
	.loading_text {
		font-style: italic;
	}
}

/* 支付方式选择区域 */
.payment_methods_section {
	margin-top: 30px;
	
	.section_title {
		font-size: 16px;
		font-weight: 500;
		color: #333;
		margin-bottom: 15px;
		padding-bottom: 10px;
		border-bottom: 1px solid #f0f0f0;
	}
	
	.payment_list {
		display: flex;
		flex-direction: column;
		gap: 0;
	}
	
	.payment_item {
		display: flex;
		align-items: center;
		padding: 15px 0;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
		transition: all 0.3s;
		
		&:last-child {
			border-bottom: none;
		}
		
		&:hover {
			background-color: #f8f9fa;
		}
		
		&.selected {
			background-color: #f0f8ff;
		}
		
		.payment_check {
			margin-right: 15px;
			
			.check_icon {
				width: 20px;
				height: 20px;
				border: 2px solid #ddd;
				border-radius: 50%;
				position: relative;
				transition: all 0.3s;
				
				&.checked {
					border-color: #1890ff;
					background-color: #1890ff;
					
					&::after {
						content: '✓';
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						color: white;
						font-size: 12px;
						font-weight: bold;
					}
				}
			}
		}
		
		.payment_info {
			display: flex;
			align-items: center;
			flex: 1;
			
			.payment_icon {
				width: 32px;
				height: 32px;
				margin-right: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				
				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
				
				.default_icon {
					font-size: 20px;
				}
			}
			
			.payment_details {
				flex: 1;
				
				.payment_name {
					font-size: 16px;
					color: #333;
					font-weight: 500;
					margin-bottom: 2px;
				}
				
				.payment_desc {
					font-size: 12px;
					color: #666;
				}
			}
		}
	}
}

/* 充值地址输入框样式 */
.recharge_input {
	.address_text {
		display: flex;
		align-items: center;
		gap: 10px;
		width: 100%;
	}
	
	.address_value {
		flex: 1;
		font-size: 14px;
		color: #333;
		background: transparent;
		border: none;
		word-break: break-all;
		font-family: monospace;
		padding: 0;
	}
	
	.copy_btn {
		flex-shrink: 0;
		padding: 4px 8px;
		background: #007bff;
		color: white;
		border-radius: 4px;
		font-size: 12px;
		cursor: pointer;
		transition: background-color 0.2s;
		
		&:hover {
			background: #0056b3;
		}
		
		&:active {
			transform: translateY(1px);
		}
	}
}

/* 原有的充值地址样式保留但不使用 */
.recharge_address {
	width: 100%;
	display: flex;
	align-items: center;
}

.qrcode_container {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 10px;
	background: white;
	border-radius: 8px;
}

.qrcode_img {
	width: 150px;
	height: 150px;
	border-radius: 4px;
}

.address_text {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
}

.address_label {
	font-size: 14px;
	color: #666;
	font-weight: 500;
}

.address_value {
	flex: 1;
	font-size: 12px;
	color: #333;
	background: white;
	padding: 8px 12px;
	border-radius: 4px;
	border: 1px solid #ddd;
	word-break: break-all;
	font-family: monospace;
}

.copy_btn {
	flex-shrink: 0;
	padding: 6px 12px;
	background: #007bff;
	color: white;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	transition: background-color 0.2s;
}

.copy_btn:hover {
	background: #0056b3;
}

.copy_btn:active {
	transform: translateY(1px);
}

/* 两元素行的样式（标签在左，值在中，右列空） */
.info_row:not(:has(.info_value_arrow)) {
	.info_label {
		width: 33.33%;
	}
	
	.info_value {
		width: 33.33%;
		justify-content: center;
	}
	
	/* 右列空着，但保持宽度 */
	&::after {
		content: '';
		width: 33.33%;
	}
}

/* 三元素行的样式（标签在左，值在中，箭头在右） */
.info_row:has(.info_value_arrow) {
	.info_label {
		width: 33.33%;
	}
	
	.info_value {
		width: 33.33%;
		justify-content: center;
	}
	
	.info_value_arrow {
		width: 33.33%;
		justify-content: right;
	}
}
.line_bottom{
	border-bottom: 1px solid #f0f0f0;
}

/* 货币行相对定位 */
.currency_row {
	position: relative;
	
	/* 覆盖通用样式，确保货币行只有两列 */
	.info_label {
		width: 33.33% !important;
	}
	
	.currency_input {
		width: 66.67% !important;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #e0e0e0;
		border-radius: 2px;
		padding: 12px 16px;
		cursor: pointer;
		transition: all 0.3s;
		
		&:hover {
			border-color: #1890ff;
		}
		
		.currency_text {
			font-size: 16px;
			color: #333;
		}
		
		.arrow_down {
			color: #999;
			font-size: 12px;
			transition: transform 0.3s;
			
			&.arrow_up {
				transform: rotate(180deg);
			}
		}
	}
	
	/* 移除通用样式的::after伪元素 */
	&::after {
		display: none !important;
	}
}

/* 货币下拉选择器 */
.currency_dropdown {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	background: #ffffff;
	border: 1px solid #e8e8e8;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	z-index: 1000;
	max-height: 200px;
	overflow-y: auto;
	
	.currency_option {
		padding: 12px 16px;
		cursor: pointer;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #f0f0f0;
		transition: background-color 0.2s;
		
		&:last-child {
			border-bottom: none;
		}
		
		&:hover {
			background-color: #f5f5f5;
		}
		
		&.selected {
			background-color: #1890ff;
			color: #ffffff;
		}
	}
}

/* 金额输入框 */
.amount_input {
	border: none;
	background: transparent;
	font-size: 16px;
	color: #333;
	text-align: center;
	width: 120px;
	
	&:focus {
		outline: none;
	}
}

/* 提交按钮 */
.submit_btn {
	width: 100%;
	height: 48px;
	background: #1890ff;
	color: #ffffff;
	border: none;
	border-radius: 50px;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 30px;
	transition: all 0.3s;
	
	&:hover {
		background: #40a9ff;
	}
	
	&.disabled {
		background: #d9d9d9;
		cursor: not-allowed;
		opacity: 0.6;
	}
	
	&.loading {
		background: #ccc;
		cursor: not-allowed;
		
		&:hover {
			background: #ccc;
		}
	}
	
	.loading_text {
		font-style: italic;
	}
}

/* 支付方式选择区域 */
.payment_methods_section {
	margin-top: 30px;
	
	.section_title {
		font-size: 16px;
		font-weight: 500;
		color: #333;
		margin-bottom: 15px;
		padding-bottom: 10px;
		border-bottom: 1px solid #f0f0f0;
	}
	
	.payment_list {
		display: flex;
		flex-direction: column;
		gap: 0;
	}
	
	.payment_item {
		display: flex;
		align-items: center;
		padding: 15px 0;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
		transition: all 0.3s;
		
		&:last-child {
			border-bottom: none;
		}
		
		&:hover {
			background-color: #f8f9fa;
		}
		
		&.selected {
			background-color: #f0f8ff;
		}
		
		.payment_check {
			margin-right: 15px;
			
			.check_icon {
				width: 20px;
				height: 20px;
				border: 2px solid #ddd;
				border-radius: 50%;
				position: relative;
				transition: all 0.3s;
				
				&.checked {
					border-color: #1890ff;
					background-color: #1890ff;
					
					&::after {
						content: '✓';
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						color: white;
						font-size: 12px;
						font-weight: bold;
					}
				}
			}
		}
		
		.payment_info {
			display: flex;
			align-items: center;
			flex: 1;
			
			.payment_icon {
				width: 32px;
				height: 32px;
				margin-right: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				
				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
				
				.default_icon {
					font-size: 20px;
				}
			}
			
			.payment_details {
				flex: 1;
				
				.payment_name {
					font-size: 16px;
					color: #333;
					font-weight: 500;
					margin-bottom: 2px;
				}
				
				.payment_desc {
					font-size: 12px;
					color: #666;
				}
			}
		}
	}
}

/* 支付类型下拉选择器样式已复用货币选择器的样式 */

/* 图片上传样式 - 全宽版本 */
.upload_row_full {
	padding: 20px 0 !important;
	display: block !important;
	border-bottom: 1px solid #f0f0f0;
	
	.upload_container_full {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.upload_box {
		width: 120px;
		height: 120px;
		border: 2px dashed #ddd;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s;
		position: relative;
		
		&:hover {
			border-color: #1890ff;
			background-color: #f0f8ff;
		}
		
		.upload_icon {
			font-size: 36px;
			color: #999;
			margin-bottom: 10px;
		}
		
		.upload_text {
			font-size: 14px;
			color: #666;
			margin-bottom: 5px;
		}
		
		.required_tip {
			font-size: 11px;
			color: #ff4d4f;
			font-weight: bold;
		}
	}
	
	.image_preview {
		position: relative;
		width: 120px;
		height: 120px;
		
		.preview_img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 8px;
			cursor: pointer;
			border: 2px solid #ddd;
		}
		
		.delete_btn {
			position: absolute;
			top: -8px;
			right: -8px;
			width: 26px;
			height: 26px;
			background: #ff4d4f;
			color: white;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 18px;
			cursor: pointer;
			line-height: 1;
			transition: all 0.3s;
			box-shadow: 0 2px 4px rgba(0,0,0,0.2);
			
			&:hover {
				background: #ff7875;
				transform: scale(1.1);
			}
		}
	}
}

/* 旧的图片上传样式 - 保留以防其他地方使用 */
.upload_row {
	.info_label.required {
		position: relative;
		
		&::after {
			content: '*';
			color: #ff4d4f;
			margin-left: 4px;
			font-size: 14px;
		}
	}
	
	.upload_container {
		width: 66.67%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.upload_box {
		width: 100px;
		height: 100px;
		border: 2px dashed #ddd;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s;
		position: relative;
		
		&:hover {
			border-color: #1890ff;
			background-color: #f0f8ff;
		}
		
		.upload_icon {
			font-size: 32px;
			color: #999;
			margin-bottom: 8px;
		}
		
		.upload_text {
			font-size: 12px;
			color: #666;
		}
		
		.required_tip {
			position: absolute;
			bottom: 5px;
			font-size: 10px;
			color: #ff4d4f;
			font-weight: bold;
		}
	}
	
	.image_preview {
		position: relative;
		width: 100px;
		height: 100px;
		
		.preview_img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 8px;
			cursor: pointer;
		}
		
		.delete_btn {
			position: absolute;
			top: -8px;
			right: -8px;
			width: 24px;
			height: 24px;
			background: #ff4d4f;
			color: white;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 18px;
			cursor: pointer;
			line-height: 1;
			transition: all 0.3s;
			
			&:hover {
				background: #ff7875;
				transform: scale(1.1);
			}
		}
	}
	
	/* 覆盖通用样式 */
	.info_label {
		width: 33.33% !important;
	}
	
	/* 移除通用样式的::after伪元素 */
	&::after {
		display: none !important;
	}
}

/* 底部导航栏样式已移至FooterTab组件 */
</style>
